export default __webpack_public_path__ + "static/media/filling_5.8d6cf8b8.jpg";